import React, { Component, Fragment } from "react";
import { BrowserRouter as Router, NavLink } from "react-router-dom";
import axios from "axios";

class Sidebar extends Component {
    state = {
        data: null
    };

    pseudoMenu = [
        { name: "Exclusives", url: "/exclusives" },
        { name: "New", url: "/new" },
        { name: "Most Viewed", url: "/most-viewed" },
        { name: "Top Categories", url: "/top-categories" },
        { name: "All Categories", url: "/all-categories" }
    ];

    componentDidUpdate() { }

    componentDidMount() {
        axios
            .get("/api/category/all")
            .then(response => {
                this.setState({
                    data: response.data.all,
                    alphabet: response.data.alphabet
                });
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    render() {

        const data = this.state.data;
        return (
            <div className="il-sidebar ml-md-n3 pr-3 bg-light">
                <nav className="il-pseudo-menu mr-n3">
                    <ul className="list-unstyled">
                        {this.pseudoMenu.map((item, key) => (
                            <li key={key}>
                                <NavLink
                                    to={item.url}
                                    className="h6 mb-1 py-3 px-4 text-dark d-block bg-light"
                                >
                                    {item.name}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
                {/* <h4 className="h5 font-weight-normal pl-3">Categories</h4> */}
                {window.innerWidth >= 768 && (
                    <nav className="il-taxonomy-menu d-none d-md-flex align-items-start">
                        <ul className="list-unstyled">
                            {!!data &&
                                Object.keys(data).map((key, index) => (
                                    <li id={`${key}-section`} key={key}>
                                        <span className="h6 bg-white text-uppercase text-primary d-block my-2 px-4 py-1">
                                            {key}
                                        </span>
                                        <ul className="list-unstyled">
                                            {data[key].map((category, key) => (
                                                <li key={key}>
                                                    <NavLink
                                                        activeClassName="active"
                                                        className="text-dark h6 small px-4 py-1 d-block mb-1"
                                                        to={category.slug}
                                                    >
                                                        {category.title}
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                ))}
                        </ul>
                        <div className="pl-2 mt-2 il-sidebar-container">
                            {!!this.state.alphabet &&
                                this.state.alphabet.map((value, key) => (
                                    <a
                                        key={key}
                                        className="il-letter-link d-block text-center mb-1 text-uppercase"
                                        href={`#${value}-section`}
                                    >
                                        {value}
                                    </a>
                                ))}
                        </div>
                    </nav>
                )}
            </div>
        );
    }
}

export default Sidebar;
